module.exports = __webpack_public_path__ + "assets/img/XT.482ec088.svg";